module.exports = __webpack_public_path__ + "static/loan-obligation-73efc90473d2c5e3c925cd4041a9fbf9.svg";